import React from 'react';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';

function PedidosGrid({ arrayPedidos, clickDelete, userPermissions }) {

    const formatarData = (isoString) => {
        if (!isoString) return '-';
        const data = new Date(isoString);
        if (isNaN(data.getTime())) return '-';
        return data.toLocaleDateString('pt-BR');
    };

    const formatarValor = (valor) => {
        return (Number(valor) || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    };

    const getStatusClass = (status) => {
        switch (status) {
            case 'Em Aberto':
                return 'badge-status-gray';
            case 'Faturado':
                return 'badge-status-yellow';
            case 'Pago Cliente':
            case 'Pago Parcial':
            case 'Pago Fornec.':
                return 'badge-status-light-blue';
            case 'Pago':
                return 'badge-status-dark-blue';
            case 'Enviado':
                return 'badge-status-light-green';
            case 'Concluído':
                return 'badge-status-dark-green';
            case 'Cancelado':
                return 'badge-status-red';
            default:
                return 'badge-status-gray';
        }
    };

    if (!arrayPedidos || arrayPedidos.length === 0) {
        return (
            <div className="pedidos-empty-state">
                <div className="pedidos-empty-icon">
                    <i className="fas fa-file-invoice-dollar"></i>
                </div>
                <h5 className="text-muted">Nenhum pedido encontrado</h5>
                <p className="text-muted small">
                    Não há pedidos cadastrados ou que correspondam aos critérios da sua pesquisa.
                </p>
                <Link to="/app/novopedido" className="empty-state-add-button">
                    <i className="fas fa-plus"></i>
                </Link>
            </div>
        );
    }

    return (
        <div className="pedidos-grid-container">
            <table className="table-custom">
                <thead>
                    <tr>
                        <th className="text-center" style={{ width: '100px' }}>Ações</th>
                        <th className="text-start col-status">Status</th>
                        <th className="text-start col-numero">Número</th>
                        <th className="text-start col-data">Data</th>
                        <th className="text-start col-cliente">Cliente</th>
                        <th className="text-start" style={{ width: '150px' }}>Valor Total</th>
                        <th className="text-start" style={{ minWidth: '120px' }}>Data Cadastro</th>
                        <th className="text-start" style={{ minWidth: '150px' }}>Usuário Cadastro</th>
                        <th className="text-start" style={{ minWidth: '120px' }}>Data Últ. Alt.</th>
                        <th className="text-start" style={{ minWidth: '150px' }}>Usuário Últ. Alt.</th>
                    </tr>
                </thead>
                <tbody>
                    {arrayPedidos.map((pedido) => (
                        <tr key={pedido.id}>
                            <td className="text-center" data-label="Ações">
                                <div className="actions-cell">
                                    <Link
                                        to={`/app/editarpedido/${pedido.id}`}
                                        className="btn-action-sm btn-edit"
                                        title="Editar"
                                        onClick={(e) => {
                                            // Validation for Edit
                                            if (userPermissions && userPermissions['editar_pedidos'] === false) {
                                                e.preventDefault();
                                                Swal.fire({
                                                    icon: 'error',
                                                    title: 'Acesso Negado',
                                                    text: 'Este usuário não possui permissão de edição. Por favor, contate o administrador.',
                                                    confirmButtonColor: '#2185c6'
                                                });
                                            }
                                        }}
                                    >
                                        <i className="fas fa-edit"></i>
                                    </Link>
                                    <button onClick={() => clickDelete(pedido.id)} className="btn-action-sm btn-delete" title="Excluir">
                                        <i className="fas fa-trash"></i>
                                    </button>
                                </div>
                            </td>
                            <td className="col-status" data-label="Status">
                                <span className={`pedidos-badge ${getStatusClass(pedido.status)}`}>
                                    {pedido.status || 'Em Aberto'}
                                </span>
                            </td>
                            <td className="col-numero" data-label="Número">{pedido.numero}</td>
                            <td className="col-data" data-label="Data">{formatarData(pedido.data_cadastro)}</td>
                            <td className="col-cliente" data-label="Cliente">
                                <span className="fw-medium text-truncate">{pedido.cliente_nome || 'Cliente não encontrado'}</span>
                            </td>
                            <td className="fw-bold text-dark" data-label="Valor Total">{formatarValor(pedido.valor_total)}</td>
                            <td data-label="Data Cadastro" style={{ minWidth: '120px' }}>{formatarData(pedido.data_cadastro)}</td>
                            <td data-label="Usuário Cadastro" style={{ minWidth: '150px' }}>{pedido.usuario_cadastro || '-'}</td>
                            <td data-label="Data Últ. Alt." style={{ minWidth: '120px' }}>{formatarData(pedido.data_ultima_alteracao)}</td>
                            <td data-label="Usuário Últ. Alt." style={{ minWidth: '150px' }}>{pedido.usuario_ultima_alteracao || '-'}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

export default PedidosGrid;